/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByRegionWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByRegionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByRegionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByRegionWidgetConfiguration>): CostSpendByRegionWidgetConfiguration {
        let obj = Object.assign(new CostSpendByRegionWidgetConfiguration(), model);
        CostSpendByRegionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByRegionWidgetConfiguration>): CostSpendByRegionWidgetConfiguration {
        if (!model) return null;
        return CostSpendByRegionWidgetConfiguration.newInstance(<CostSpendByRegionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByRegionWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByRegionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByRegionWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByRegionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
